import { findMultiplet } from './findMultiplet';
/**
 * check if the input string corresponds to a multiplet (pattern), it could has a common name, acs or one letter abbreviation.
 * @param string - pattern name or abbreviation.
 * @param rejected - list of patterns that should not match with the input pattern. e.g 'massive' as input will return false if rejected = ['m'].
 */
export function checkMultiplet(string, rejected = []) {
    const multiplet = findMultiplet(string);
    return (multiplet &&
        !rejected.includes(multiplet.label) &&
        !rejected.includes(multiplet.value) &&
        !multiplet.names.some((name) => rejected.includes(name)));
}
//# sourceMappingURL=checkMultiplet.js.map